export default {
  COLOR: {
    BACKGROUND: '#fff',
    PRIMARY: '#10c0bc',
  },

  MOTION: {
    DURATION: 500,
  },
};
